import type { RagNavConfig } from "@/apps/rag/rag-nav";

export const SUPERVISOR_CHATS_REFRESH = "supervisor-chats-refresh";
export const SUPERVISOR_NEW_CHAT = "supervisor-new-chat";

export function requestNewSupervisorChat() {
  window.dispatchEvent(new Event(SUPERVISOR_NEW_CHAT));
}

export type SupervisorConversation = {
  id: string;
  title: string;
  updatedAt?: string;
};

export function refreshSupervisorChats() {
  window.dispatchEvent(new Event(SUPERVISOR_CHATS_REFRESH));
}

export function supervisorChatNav(conversations: SupervisorConversation[]): RagNavConfig {
  return {
    sectionLabel: "",
    items: [],
    subSectionLabel: conversations.length > 0 ? "Recent" : undefined,
    subItems: conversations.map((conversation) => ({
      id: conversation.id,
      to: `/chat/${conversation.id}`,
      label: conversation.title || "New chat",
    })),
    subItemsSearchable: conversations.length > 0,
    footerAction: {
      to: "/chat",
      label: "New chat",
    },
  };
}
